<template>
<div class="item" @click="_onPressToNavigate('', 'studentInfo', {user_id: item.id})">
    <div class="center">
        <img :src="item.face_image || item.avatar" alt="">
        <div>
            <div>
                <p>{{item.name}}（{{item.real_name || '未实名'}}）</p>
                <div>{{item.subject.name || '未解锁'}}</div>
            </div>
            <p>{{item.mobile}}</p>
            <span>加入时间：{{item.team_member_time}}</span>
        </div>
    </div>
    <div class="footer">
        <p>课程消费: <span>{{item.subject_pay_sum}}元</span></p>
        <p>商城消费: <span>{{item.shop_pay_sum}}元</span></p>
    </div>
</div>
</template>

<script>
export default {
    name: "inheritorItem",
    props: ['item'],
    data() {
        return {

        };
    },
    methods: {
        _onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if(!url) return;
            window.location.href = url;
        },
    },
};
</script>

<style lang="less" scoped>
.item {
    padding: 10px;
    border: 1px dashed #f3f0ee;

    .center {
        margin-bottom: 5px;
        display: flex;

        >img {
            width: 7rem;
            height: 7rem;
            object-fit: cover;
            background: #eee;
            margin-right: 1rem;
            border-radius: 0.5rem;
        }

        >div {
            flex: 1;
            height: 7rem;
            display: flex;
            flex-direction: column;
            justify-content: space-around;

            >div {
                display: flex;
                align-items: center;

                >p {
                    flex: 1;
                    font-size: 14p;
                    color: #333;
                }

                div {
                    padding: 2px 8px;
                    border-radius: 4px;
                    border: 1px solid #7181EB;
                    font-size: 12px;
                    color: #7181EB;
                }
            }

            >p {
                font-size: 13px;
                color: #333;
            }

            >span {
                font-size: 13px;
                color: #999;
            }
        }
    }

    .footer {
        display: flex;
        margin-top: 1rem;
        align-items: center;
        justify-content: space-between;

        p {
            color: #333;
            font-size: 1.4rem;

            span {
                color: #FF0000;
                font-weight: 600;
            }
        }
    }
}
</style>
